<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id || index" :row-index="index + 1">
      <van-row class="detail-row">
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>供应商编码：</span>
        <span>{{ item.suppId }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>税率(%)：</span>
        <span>{{ item.taxRate }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>含税单价：</span>
        <span>{{ item.taxPriceAmount }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>币种：</span>
        <span>{{ item.currencyDict | dictFilter(currencyOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>价格类型：</span>
        <span>{{ item.priceTypeDict | dictFilter(priceTypeOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>价格失效周期规则：</span>
        <span>{{ item.expireRuleName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>处理方式：</span>
        <span>{{ item.priceHandleTypeDict | dictFilter(priceHandleTypeOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>顺延天数：</span>
        <span>{{ item.putOffDays }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>新失效规则：</span>
        <span>{{ item.newExpireRuleName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>数据来源：</span>
        <span>{{ item.dataSourceDict | dictFilter(dataSourceOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>调价任务编码：</span>
        <span>{{ item.priceTaskCode }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>备注：</span>
        <span>{{ item.remark }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'PriceLifespanChangeDetailList',
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currencyOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    priceTypeOptions() {
      return this.$store.getters.dicts.price_type
    },
    priceHandleTypeOptions() {
      return this.$store.getters.dicts.price_handle_type_dict
    },
    dataSourceOptions() {
      return this.$store.getters.dicts.data_source_dict
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-row span:first-child {
  color: #666666;
}
.detail-row span:last-child {
  color: #262626;
}
</style>
